import { Component } from 'react';
import { getAllItems } from '../../services/JsonFetchService.js';
import './Documents.css';

class Documents extends Component {
    constructor() {
        super();
        this.state = { infoItems: [] };

        this.showDocument = this.showDocument.bind(this);
    }

    showDocument(index) {
        if (this.state.infoItems[index].file === '') {
            window.open(this.state.infoItems[index].thumbnail)
        }
        else {
            window.open(this.state.infoItems[index].file)
        }
    }

    async componentDidMount() {
        const infoItems = await getAllItems('/documents/documents.json');
        if (infoItems.length > 0) {
            this.setState({ infoItems: infoItems })
        }
    }

    render() {
        return (
            <div>
                <h2 className='documents__title'>Документы</h2>
                <div className="container-fluid">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                        {this.state.infoItems.map((item, index) => (
                            <div className="col text-center" key={index}>
                                <img onClick={this.showDocument.bind(null, index)} className="document__thumbnail" src={item.thumbnail} alt="" />
                                <h5 className="document__title">{item.title}</h5>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default Documents;